var SharedModule = (function () {
    function SharedModule() {
    }
    return SharedModule;
}());
export { SharedModule };



// WEBPACK FOOTER //
// ./src/component/shareModule.ts.pre-build-optimizer.js